import { createLoaderImp } from '../../../components/ozmoit/common/loader-imp';
import { getSectionsAction } from '../actions';

const {
  useLoader: useSectionsLoader,
  LoaderConsumer: SectionsConsumer,
  LoaderProvider,
} = createLoaderImp({
  action: getSectionsAction,
});

function SectionsLoader({
  children,
  ...props
}: Parameters<typeof LoaderProvider>[0]) {
  const defaultQuery = { ...props.defaultQuery };
  return (
    <LoaderProvider {...props} defaultQuery={defaultQuery}>
      {children}
    </LoaderProvider>
  );
}

export { SectionsLoader, SectionsConsumer, useSectionsLoader };
